import Classic from './Classic';   // Template 1 — exact current production page
import Modern from './Modern';      // Template 2 — modern e-commerce tracker
import Minimal from './Minimal';    // Template 3 — minimal / editorial

// Single source of truth for the DIY designs. Used by both the live tracking page
// and the merchant preview, so the two can never drift. Keys mirror TrackingTemplateEnum.
const MAP = { CLASSIC: Classic, MODERN: Modern, MINIMAL: Minimal };

export default function TemplateRenderer({ template, brand, order, preview, children }) {
    const Tpl = MAP[(template || 'CLASSIC').toUpperCase()] || Classic;
    return <Tpl brand={brand} order={order} preview={preview}>{children}</Tpl>;
}
